import './styles.scss';
import * as UI from './styled';
import { useDisplay } from '../../contexts/display';

export type PropsProgressCircle = {
    percent: number,
    size?: number,
    fontSize?: number,
    children?: React.ReactNode;
}

const ProgressCircle = ({ percent, size, fontSize, children }: PropsProgressCircle) => {
    const { isMobile } = useDisplay();

    return (
        <UI.Container percent={Math.round(percent)} width={size} fontSize={fontSize} ignorePercentLabel={children != null}>
            <span className={`c-circular-progress ${isMobile && 'mobile-circular-progress'}`}>{children}</span>
        </UI.Container>
    )
}

export default ProgressCircle;